<template>
  <v-container id="profile-form" fluid>
    <breadcrumbs />
    <h1 class="mb-2">
      Профиль
    </h1>

    <loader v-if="loading" />

    <v-form v-else ref="form" v-model="valid">
      <v-container fluid>
        <v-row>
          <v-col cols="12" md="6">
            <!-- Пароль -->
            <v-text-field
              v-model="password"
              outlined
              label="Пароль"
              :loading="loading"
              :disabled="loading"
              :type="passwordFieldType"
              :append-icon="passwordFieldIcon"
              :error-messages="getErrorMsg('password')"
              @click:append="showPassword = !showPassword"
            />
            <v-text-field
              v-model="repeatPassword"
              outlined
              label="Повторите пароль"
              required
              :rules="[
                (v) => v === password || 'Пароли должны быть одинаковыми',
              ]"
              :loading="loading"
              :disabled="loading"
              :type="passwordFieldType"
              :append-icon="passwordFieldIcon"
              @click:append="showPassword = !showPassword"
            />
            <!-- Загрузка файла -->
            <upload-image
              v-model="data.image"
              label="Загрузить файл"
              color="primary"
              dialog-width="500"
              max-img-height="500"
              max-img-width="500"
            >
              <v-icon left v-text="`mdi-tray-arrow-up`" />
              Загрузить фото
            </upload-image>
          </v-col>
          <v-col cols="12" md="7">
            <v-row>
              <v-col cols="6">
                <v-btn
                  class="mb-2"
                  block
                  large
                  color="success"
                  :loading="loadingForm"
                  :disabled="loading"
                  @click.prevent="editProfile({ redirect: true })"
                >
                  Сохранить
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  block
                  large
                  color="error"
                  :loading="loadingForm"
                  :disabled="loading"
                  @click.prevent="$router.back('/')"
                >
                  Отменить
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess">
      Изменения сохранены
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import rules from '@/mixins/rules'
  import Loader from '@/components/loader/Loader'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import UploadImage from '@/components/UploadImage.vue'
  import profileApi from '@/api/profile'
  import LocalStorageService from '@/services/refresh.service'

  export default {
    name: 'ProfileForm',
    components: {
      UploadImage,
      Loader,
    },
    mixins: [rules, mixinSnackbarMessage],
    data () {
      return {
        data: {
          image: '',
        },
        password: '',
        repeatPassword: '',
        valid: true,
        loading: false,
        loadingForm: false,
        snackbar: false,
        snackbarSuccess: false,
        showPassword: false,
        errorMessages: {},
      }
    },
    computed: {
      ...mapState({
        user: (state) => state.auth.user || {},
      }),
      passwordFieldIcon () {
        return this.showPassword ? 'mdi-eye-off' : 'mdi-eye'
      },
      passwordFieldType () {
        return this.showPassword ? 'text' : 'password'
      },
    },
    created () {
      if (this.user) {
        this.data.image = this.user.image
      } else {
        this.fetchProfile()
      }
    },
    methods: {
      async fetchProfile () {
        this.loading = true

        try {
          const response = await this.$store.dispatch('auth/fetchUser')
          this.data.image = response.image
        } catch (e) {
          this.showErrorFromResponse(e)
        } finally {
          this.loading = false
        }
      },
      getErrorMsg (key) {
        return this.errorMessages[key] ? this.errorMessages[key] : ''
      },
      async editProfile () {
        this.errorMessages = {}
        const valid = this.$refs.form.validate()

        if (!valid) {
          this.showSnackbar()
          return
        }

        this.loadingForm = true

        if (this.password) {
          this.data.password = this.password
        }

        try {
          const saved = await profileApi.editProfile(this.data)

          // Пароль сменён: бэк отозвал старый токен этого устройства по iat и прислал свежий
          if (saved && saved.token) {
            LocalStorageService.setToken(saved.token)
          }

          const response = await this.$store.dispatch('auth/fetchUser')
          this.updateUserDataInLocalStorage(response)

          this.data.image = response.image
          this.data.password = null
          this.password = null
          this.repeatPassword = null
          this.snackbarSuccess = true

          setTimeout(() => {
            this.snackbarSuccess = false
          }, 3000)
        } catch (err) {
          this.showErrorFromResponse(err)

          if (err.response && err.response.data && err.response.data.data) {
            this.errorMessages = err.response.data.data
            this.showSnackbar()
          }
        } finally {
          this.loadingForm = false
        }
      },
      updateUserDataInLocalStorage (userData) {
        const data = JSON.parse(localStorage.getItem('user'))
        data.data = userData
        localStorage.setItem('user', JSON.stringify(data))
      },
      showSnackbar () {
        this.snackbar = true
        document.getElementById('profile-form').scrollIntoView({
          behavior: 'smooth',
        })

        setTimeout(() => {
          this.snackbar = false
        }, 3000)
      },
    },
  }
</script>
